/**
 * Stat definitions and registry for Idle Depths.
 *
 * @deprecated This module is deprecated. Stats are now registered via the
 * content pack system. See `apps/web/content-packs/core/content/stats.ts`
 * for the new implementation. This module is kept for backward compatibility
 * with character creation but should not be used for new code.
 *
 * Migration guide:
 * - Stats are now defined in content packs
 * - Use `gameStore.content.get('stats', 'health')` to retrieve stats
 * - Use `gameStore.content.getAll('stats')` to get all stats
 */

/* eslint-disable @typescript-eslint/no-deprecated */

import type { StatDefinition } from '../types/stats.js';

/**
 * Health stat definition.
 *
 * @deprecated Use content pack stats. This constant is kept for backward
 * compatibility with character creation (createDefaultStats).
 */
export const HEALTH_STAT: StatDefinition = {
  id: 'health',
  name: 'Health',
  icon: 'heart',
  category: 'vital',
  defaultValue: 100,
  defaultMaximum: 100,
  isVisible: true,
  displayOrder: 0,
};

/**
 * Registry of all stat definitions.
 *
 * @deprecated Use content pack ContentRegistry instead.
 */
const statRegistry = new Map<string, StatDefinition>([[HEALTH_STAT.id, HEALTH_STAT]]);

/**
 * Get a stat definition by ID.
 *
 * @deprecated Use `gameStore.content.get('stats', id)` instead.
 * @param id - The stat ID to look up
 * @returns The stat definition, or undefined if not found
 */
export function getStatDefinition(id: string): StatDefinition | undefined {
  return statRegistry.get(id);
}

/**
 * Get all registered stat definitions sorted by display order.
 *
 * @deprecated Use `gameStore.content.getAll('stats')` instead.
 * @returns Array of all stat definitions
 */
export function getAllStatDefinitions(): StatDefinition[] {
  return Array.from(statRegistry.values()).sort((a, b) => a.displayOrder - b.displayOrder);
}

/**
 * Register a new stat definition.
 *
 * @deprecated Stats should be registered via content packs.
 * @param definition - The stat definition to register
 * @throws Error if a stat with the same ID already exists
 */
export function registerStat(definition: StatDefinition): void {
  if (statRegistry.has(definition.id)) {
    throw new Error(`Stat "${definition.id}" is already registered`);
  }
  statRegistry.set(definition.id, definition);
}

/**
 * Check if a stat is registered.
 *
 * @deprecated Use `gameStore.content.has('stats', id)` instead.
 * @param id - The stat ID to check
 * @returns True if the stat is registered
 */
export function isStatRegistered(id: string): boolean {
  return statRegistry.has(id);
}
